import styled, { css } from 'styled-components'
import Wallpaper from '../../assets/images/wallpaper.png'

export const HomeWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: stretch;
    max-width: 1440px;
    margin: auto;

    @media (min-width: ${theme.ToRem(1024)}) {
      flex-wrap: nowrap;
    }

    @media (min-width: ${theme.ToRem(1200)}) {
      padding: 0 4rem;
      height: unset;
      min-height: 40rem;
      min-width: 83rem;
    }
  `}
`

export const HomeHeaderWrapper = styled.div`
  ${({ theme, isAlternativeActive }) => css`
    background-color: ${theme.colors.primary.default};
    color: ${theme.colors.white};
    background-image: url(${Wallpaper});

    width: 100%;
    position: relative;

    @media (max-width: 732px) {
      height: 30%;
    }

    @media (max-width: 320px) {
      height: 60%;
    }

    @media (min-width: ${theme.ToRem(1024)}) {
      width: 34rem;
      background-size: contain;
    }

    ${isAlternativeActive &&
    css`
      filter: grayscale(1);

      &::before {
        width: 100%;
        height: 100%;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        background-color: rgba(0, 0, 0, 0.35);
      }
    `}
  `}
`

export const HomeHeaderArea = styled.div`
  ${({ theme }) => css`
    height: 100%;
    min-height: 22vh;
    padding: 0 2rem;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    display: flex;
    position: relative;

    @media only screen and (max-width: 384px) and (min-width: 256px) {
      min-height: 32vh;
    }

    @media (min-width: ${theme.ToRem(1024)}) {
      width: 90%;
      margin: 0 auto;
    }
  `}
`

export const HomeHeaderTitle = styled.div`
  ${({ theme }) => css`
    line-height: 1.5;

    @media (max-width: 732px) {
      width: 100%;
    }

    @media (min-width: ${theme.ToRem(1024)}) {
      font-size: 3rem;
      line-height: initial;
    }
  `}
`

export const HomeHeaderSubtitle = styled.div`
  ${({ theme }) => css`
    padding-top: 1rem;
    clear: both;
    line-height: 1.5;

    @media (min-width: ${theme.ToRem(1024)}) {
      display: block;
    }
  `}
`

export const HomeContentWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.light};
    color: ${theme.colors.dark};
    width: 100%;

    @media (min-width: ${theme.ToRem(1024)}) {
      width: 49rem;
    }
  `}
`

export const HomeContentForm = styled.div`
  max-width: 470px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  height: 100%;
  justify-content: center;

  & > div:first-child {
    padding: 2.25rem 0 0.5rem;
  }

  &.hidden {
    display: none;
  }
  &.visible {
    display: flex;
  }
`

export const HomeContentFormTitle = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 0;
    text-align: center;
    font-size: ${theme.ToRem(20)};
    font-weight: 500;
    max-width: 432px;
    margin: 0 auto;
  `}
`

export const HomeContentFormText = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 0;
    text-align: center;
    font-size: ${theme.ToRem(16)};
    max-width: 525px;
    margin: 0 auto;
  `}
`

export const HomeContentFormInputContainer = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 1.5rem 0;
    max-width: 432px;
    margin: 0 auto;
    input {
      width: 100%;
    }
    @media (min-width: ${theme.ToRem(1024)}) {
      padding: 0.75rem 0 0;
    }
  `}
`

export const HomeContentFormInputCta = styled.div`
  ${({ theme }) => css`
    padding: 0 1.5rem 0.5rem;
    color: ${theme.colors.darkBlue};
    button {
      font-size: 1rem;
    }
    max-width: 432px;
    margin: 0 auto;

    @media (min-width: ${theme.ToRem(1024)}) {
      padding: 0 0 0.75rem;
    }
  `}
`

export const HomeContentFormSubmitContainer = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 1.5rem;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    line-height: 1.5;
    max-width: 432px;
    margin: 0 auto;

    & > div {
      margin-bottom: 0;
    }

    &.hidden {
      display: none;
    }
    &.visible {
      display: block;
    }

    @media (min-width: ${theme.ToRem(1024)}) {
      padding: 0.75rem 0;
    }
  `}
`

export const HomeContentFormBottomCtaContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    text-align: center;
    flex-wrap: wrap;
    padding: 0.5rem 0;
    & > div {
      margin: 0.5rem 1rem;
    }

    &.hidden {
      display: none;
    }
    &.visible {
      display: block;
    }

    @media (min-width: ${theme.ToRem(1024)}) {
      padding: 0.75rem 0;
    }

    ${({ anchor }) =>
      anchor &&
      css`
        padding: 0.5rem 0;

        a {
          display: block;
        }
      `}
  `}
`

export const HomeContentErrorContainer = styled.div`
  ${({ theme, secondStep }) => css`
    display: none;
    margin: 1rem 0;
    text-align: center;
    span {
      ${theme.fonts.regular};
      color: ${theme.colors.error};
      line-height: 1.5;
      display: inline-block;
    }

    &.visible {
      display: block;
    }

    ${secondStep &&
    css`
      text-align: center;
      span {
        ${theme.fonts.bold};
        font-size: 0.75rem;
        margin: 0 auto;
      }
    `}
  `}
`

export const HomeContentErrorPwdContainer = styled.div`
  ${({ theme, secondStepPwd }) => css`
    width: 288px;
    display: none;
    margin: 0 0 1rem 0;
    span {
      ${theme.fonts.regular};
      color: ${theme.colors.error};
      line-height: 1.5;
      text-align: left !important;
      display: inline-block;
      font-size: 10px;
    }

    &.visible {
      display: block;
    }

    ${secondStepPwd &&
    css`
      text-align: center;
      span {
        font-family: 'Maven Pro', sans-serif;
        color: rgb(235, 48, 48);
        line-height: 1.5;
        text-align: center;
      }
    `}
  `}
`

export const HomeContentCta = styled.div`
  display: inline-flex;
  justify-content: center;
  padding: 0.5rem 0;
`

export const RecaptchaInfoContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    padding-bottom: 1rem;
    text-align: center;
    font-family: 'Maven Pro', sans-serif;
    font-size: 0.75rem;

    @media (min-width: ${theme.ToRem(480)}) {
    }
  `}
`

export const ButtonsFocusContainer = styled.span`
  ${({ theme }) => css`
    &:focus-within {
      border: 2px solid ${theme.colors.primary.hover};
    }
  `}
`
